import React from 'react';
import {View} from 'react-native';
// import Profile from 'component/screen/Profile/Profile';
import {isEmpty} from 'lodash';

import Avatar from '/component/base/Avatar';
import Text from '/component/base/Text';
import {ProfilePage, UserProfileModal} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';
import {generateComponentCallback} from '/util/component.util';
import {formatTimeByOffset, getDateUtilDefaultInstance} from '/util/date.util';
import {withHOC} from '/util/hoc.util';

import {styles} from './ClientInfo.style';

interface ReportRecordData {
  firstName: string;
  lastName: string;
  avatarUrl: string | null;
  accountEmail: string | null;
  activatedOn: string | null;
}

interface ClientInfoProps {
  tt: (key: string, args?: any) => string;
  reportRecordData: ReportRecordData | null;
}

export const ClientInfo = ({
  tt = withTranslation.ttDefaultProp,
  reportRecordData = null,
}: ClientInfoProps) => {
  const {firstName, lastName, avatarUrl, accountEmail, activatedOn} =
    reportRecordData ?? {};

  const convertedToActivatedOnTime = formatTimeByOffset(activatedOn);
  return (
    <View style={styles.header}>
      <Avatar
        size={56}
        isCoach={false}
        avatarUrl={avatarUrl ?? null}
        avatarKey={accountEmail ?? null}
      />
      <View style={styles.headerText}>
        <Text variant="button" testID={ProfilePage.profileFullName}>
          {firstName} {lastName}
        </Text>
        <Text emphasis="low" testID={UserProfileModal.activationDate}>
          {tt(
            'startedDate',
            generateComponentCallback({
              component: (
                <>
                  Client since{' '}
                  {isEmpty(convertedToActivatedOnTime)
                    ? ''
                    : getDateUtilDefaultInstance().formatDate(
                        convertedToActivatedOnTime,
                        'MMMM d, yyyy',
                      )}
                </>
              ),
            }),
          )}
        </Text>
      </View>
    </View>
  );
};

export default withHOC(withTranslation('reportCard.coach'))(ClientInfo);
